import BaseProxy from './Base';

class UsersProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('users', parameters, 'api/v1');
  }

  delete(params) {
    return this.submit('delete', `/${this.endpoint}`, params);
  }

  create(item) {
    return this.submit('put', `/${this.endpoint}`, item);
  }

  getItems() {
    return this.load();
  }

  update(id, item) {
    return this.submit('post', `/${this.endpoint}/${id}`, item);
  }
}

export default UsersProxy;
